module.exports = __webpack_public_path__ + "img/39.d59556f3.jpg";